import { AuthService } from "@/services/auth/auth.service";
import { HawkingsService } from "@/services/hawking/hawkings";

const _hawkingsService = new HawkingsService();

const getChatsAction = ({ commit }, { roomId, page, callback, callbackError }) => {
  _hawkingsService
    .getChats(roomId, page)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getChatHistoryAction = ({ commit }, { idChat, roomId, page, callback, callbackError }) => {
  _hawkingsService
    .getChatHistory(idChat, roomId, page)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const sendExamGeneratorAction = ({ commit }, { id, callback, callbackError }) => {
  _hawkingsService
    .sendExamGenerator(id)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createExamAction = ({ commit }, { data, callback, callbackError }) => {
  _hawkingsService
    .createExam(data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const downloadExamAction = ({ commit }, { id, title, callback, callbackError }) => {
  _hawkingsService
    .downloadExam(id)
    .then((response) => {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      const url = window.URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.setAttribute('download', title + '.docx');
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createChatAction = ({ commit }, { roomId, callback, callbackError }) => {
  _hawkingsService
    .createChat(roomId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createTitleChatAction = ({ commit }, { id, roomId, callback, callbackError }) => {
  _hawkingsService
    .createTitleChat(id, roomId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const fetchSendMessageChatAction = ({ commit }, { data, id, roomId, callback, callbackError }) => {
  _hawkingsService
    .fetchSendMessageChat(data, id, roomId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const fetchSendMessageChatGPTAction = ({ commit }, { data, id, callback, callbackError }) => {
  _hawkingsService
    .fetchSendMessageChatGPT(data, id)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const setShowHawkingToolAction = ({ commit }, payload: boolean): void => {
  commit("setShowHawkingTool", payload);
};

const registerAction = (
  { commit },
  { data, callback, callbackError }
) => {
  _hawkingsService
    .register(data)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => callbackError(error));
};

const activateRegistrationAction = (
  { commit },
  { token, callback, callbackError }
): void => {
  _hawkingsService
    .activateRegistrationUser(token)
    .then((response) => {
      if (response.data.token) {
        localStorage.clear();
        const _autService = new AuthService();
        _autService.decodeJwt(response.data);
      }
      callback(response);
    })
    .catch((error) => {
      callbackError();
    });
};

const myBundleAction = (
  { commit },
  { data, callback, callbackError }
) => {
  _hawkingsService
    .myBundle()
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => callbackError(error));
};

const getBotChatsAction = ({ commit }, { botId, page, callback, callbackError }) => {
  _hawkingsService
    .getBotChats(botId, page)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createBotChatAction = ({ commit }, { botId, callback, callbackError }) => {
  _hawkingsService
    .createBotChat(botId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const fetchSendBotMessageChatAction = ({ commit }, { data, id, callback, callbackError }) => {
  _hawkingsService
    .fetchSendBotMessageChat(data, id)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createBotTitleChatAction = ({ commit }, { id, callback, callbackError }) => {
  _hawkingsService
    .createBotTitleChat(id)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getBotChatHistoryAction = ({ commit }, { idChat, page, callback, callbackError }) => {
  _hawkingsService
    .getBotChatHistory(idChat, page)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getQuestionsAction = ({ commit }, { idChat, roomId, callback, callbackError }) => {
  _hawkingsService
    .getQuestions(idChat,roomId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getSingleQuestionsAction = ({ commit }, { idChat, roomId, callback, callbackError }) => {
  _hawkingsService
    .getSingleQuestions(idChat)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

export default {
  getChatsAction,
  getChatHistoryAction,
  sendExamGeneratorAction,
  downloadExamAction,
  createChatAction,
  createTitleChatAction,
  fetchSendMessageChatAction,
  fetchSendMessageChatGPTAction,
  createExamAction,
  setShowHawkingToolAction,
  registerAction,
  activateRegistrationAction,
  myBundleAction,
  getBotChatsAction,
  createBotChatAction,
  fetchSendBotMessageChatAction,
  createBotTitleChatAction,
  getBotChatHistoryAction,
  getQuestionsAction,
  getSingleQuestionsAction,
}